import { Link, ModalOpen, useModel, useRoute } from "@bcm-dev/bcms-vite";
import ButtonContainer from 'compid/shared/containers/ButtonContainer';
import CenterColumnContainer from 'compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer';
import BillerView from 'compid/shared/views/BillerView';
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";
import TableView, { TableRowView } from 'compid/shared/views/TableView';
import UIButton from 'compid/ui/UIButton';
import { Biller, Payment } from "model";
import React from "react";
import "./styles.css";

/**
 * @function ScheduledPaymentView
 * @return {React.Component}
 * @exported true
 * @description The main component for ScheduledPaymentView.
 * ScheduledPaymentView is shown for Scheduled Payments in the ViewPaymentPage.
 */

export default function ScheduledPaymentView(props) {
  const { branding }= useModel();
  const navigate = useRoute();
  const payment = props.payment ?? Payment.firstInstanceOf();
  // All confirmation numbers for payments will be the same for now.
  const confirmationNumber = payment.confirmationNumber ? payment.confirmationNumber : "TN2RH-1LNHX";
  const biller = payment.to;
  const isPaper = biller.paymentType === "paper";
  const isVirtualCard = biller.paymentType === "virtualCard";
  const fromAccount = payment.from;
  const paymentDateFormatted = payment.date.format(`M d`);
  const deliverDateFinePrint = `Your check maybe cashed, and the money withdrawn from your account, before, on, or after ${ paymentDateFormatted }.`
  const deliverDateFinePrintPaper = `Money was withdrawn from your account on ${ paymentDateFormatted }. The payment was applied on ${ paymentDateFormatted }.`
  const deliverDateFinePrintElectronic = `Money was withdrawn from your account on [[date before Estimated Delivery]]. The Payment was applied on [[date before Estimated Delivery]].`
  // const deliveryMethodMessage = isPaper ? "Check" : "Electronic";
  const editPayment = id => () => navigate(`/editPaymentWorkflow/${ id }`);
  const done = () => navigate(-1);
  const billerHasAutopay = biller.autopay === undefined ? false : true;
  const withdrawnOnDate = Payment.getWithdrawOnDate(payment.date, payment.to.paymentType, branding);
  const withdrawnOnLabel = withdrawnOnDate.format("M d");
  const deliverByLabel = payment.date.format("M d");
  const hasRealTimeGoodFunds = Payment.hasRealTimeGoodFunds(payment.to.paymentType, branding);
  const deliveryMethodMessage = isPaper ? hasRealTimeGoodFunds ? "Check" : "Overnight Check" : "Electronic";
  
  return(
    
        <div className="flex-container flex-vertical flex-width scheduled-payment-view">
          <div className="flex-height flex-container flex-vertical upper-content-container">
            {/* This autopay banner is not shown for now. */}
            {/*
            <InfoAlertNotificationView text={
              <div className="flex-container flex-horizontal align-center space-between">
                <p>Payment was scheduled automatically</p>
                <DisabledPrompt>
                  <Link className="blue-text view-autopay semi-bold-text">View autopay</Link>
                </DisabledPrompt>
              </div>} />
            */}
              <BillerView biller={ biller }
              paymentInfo={
                  <BillerPaymentView 
                      amount={ payment.amount }
                      status={ payment.status }
                      date={ payment.formatDate }
                      showAutopay={ payment.hasRelatedAutopay }
                      description={<>Last<span className="show-on-desktop payment">Payment</span><span className="show-on-mobile payment">pmt</span></>} />
              } 
            />
          </div>
          <div className="flex-height flex-width flex-container all-center">
            <CenterColumnContainer>
              <TableView>
                <TableRowView label="Confirmation" labelClass="semi-bold-text" data={ confirmationNumber } />
                <TableRowView label="Amount" labelClass="semi-bold-text" data={ payment.amount.format() } />
                <TableRowView label="Pay from" labelClass="semi-bold-text" data={ fromAccount.name + " " + fromAccount.number } />
                { isPaper && 
                  !hasRealTimeGoodFunds && <>
                    <TableRowView label="Estimated delivery" labelClass="semi-bold-text" data={ payment.date.format('M d') } />
                    <TableRowView label="" data={ deliverDateFinePrint } dataClass="fine-print" />
                    <TableRowView label="" data={ deliverDateFinePrintPaper } dataClass="fine-print" />
                  </> }
                  {hasRealTimeGoodFunds && <>
                   <TableRowView label="Estimated delivery" labelClass="semi-bold-text" data={ payment.date.format('M d') } />
                   
                 </> 
                  }   
                { !isPaper && <TableRowView label="Deliver by" labelClass="semi-bold-text" data={ deliverByLabel } /> }
                <TableRowView label="Withdraw on" labelClass="semi-bold-text" data={ withdrawnOnLabel } />
                <TableRowView label="Delivery method" labelClass="semi-bold-text" data={ deliveryMethodMessage } />
                
              </TableView>
              { isVirtualCard && <span className="sub-text">{ Biller.getVirtualCardDisclaimer(true) }</span> }
              <ButtonContainer className="form-button-container">
                <UIButton className="secondary-button" onClick={ editPayment(payment.id) } dataPoint="Edit_Payment_Button">Edit payment</UIButton>
                <UIButton className="primary-button" onClick={ done } dataPoint="Done_Payment_Button">Done</UIButton>
              </ButtonContainer>
              
              <Link className="text-center semi-bold-text cancel-link link-button">
                <ModalOpen id="CancelPaymentModal" data={ {openedModalFromPage: "scheduledPayment", paymentID: payment.id } }>Cancel payment</ModalOpen>
              </Link>
            </CenterColumnContainer>
          </div>
        </div>
  );
}